import React, { useState, useEffect } from 'react';

interface RenderTimeProps {
  time: number;
  onComplete: () => void;
}

const displayTimeRemaining = (duration: number) => {
  const seconds = Math.floor((duration / 1000) % 60);
  const minutes = Math.floor((duration / (1000 * 60)) % 60);
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

const TimerCountdown: React.FC<RenderTimeProps> = ({ time, onComplete }) => {
  const [timeRemaining, setTimeRemaining] = useState(time);
  const [timeRemainingDisplay, setTimeRemainingDisplay] = useState(displayTimeRemaining(time));

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const timeOut = (timeLeft: number) => {
      timer = setTimeout(() => {
        const newTime = timeLeft - 1000;
        setTimeRemaining(newTime);
        if (newTime > 0) {
          timeOut(newTime);
        } else {
          onComplete();
        }
      }, 1000);
    };
    timeOut(time);
    return () => window.clearTimeout(timer);
  }, [time, setTimeRemaining, onComplete]);

  useEffect(() => {
    setTimeRemainingDisplay(displayTimeRemaining(timeRemaining));
  }, [timeRemaining]);

  return <span>{timeRemainingDisplay}</span>;
};

export default TimerCountdown;
